<script setup lang="ts">
import { RouterView } from 'vue-router'
import ErrorBoundary from '@/components/ErrorBoundary.vue'
import LocaleSwitcher from '@/components/LocaleSwitcher.vue'
import RouterTransition from '@/components/RouterTransition.vue'
</script>

<template>
  <ErrorBoundary>
    <RouterTransition>
      <RouterView />
    </RouterTransition>
    <LocaleSwitcher />
  </ErrorBoundary>
</template>
